import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TakingSamplesIcon = createIcon({
    viewBox: '0 0 24 25',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18.5516 10.2078L19.1037 10.76L19.1042 10.7604C19.4107 11.067 19.9078 11.067 20.2144 10.7604C20.521 10.4538 20.521 9.95677 20.2144 9.65019L14.6633 4.09908C14.3567 3.7925 13.8596 3.7925 13.553 4.09908C13.2465 4.40565 13.2465 4.90272 13.553 5.2093L13.5535 5.20974L14.1107 5.76694L14.1095 5.76811L10.7809 9.09668H10.7776L4.11627 15.758C3.08007 16.7942 2.91943 18.3744 3.63435 19.5793C3.76574 19.8012 3.9268 20.0103 4.11751 20.201C5.34383 21.4273 7.33208 21.4273 8.5584 20.201L18.5504 10.209L18.5516 10.2078ZM13.0014 9.09668L17.4381 9.09669L15.2197 6.87833L13.0014 9.09668ZM21.1963 16.1031C21.1963 16.9702 20.4934 17.6732 19.6262 17.6732C18.7591 17.6732 18.0562 16.9702 18.0562 16.1031C18.0562 15.2359 18.8412 13.7479 19.6262 12.9629C20.4113 13.7479 21.1963 15.2359 21.1963 16.1031ZM20.6918 15.3515C20.7468 15.5348 20.7707 15.7176 20.7763 15.8867C20.7932 16.3994 20.4852 16.513 20.4168 16.0046C20.3946 15.8396 20.3631 15.6574 20.3075 15.472C20.251 15.2836 20.1754 15.1117 20.102 14.9599C19.8807 14.5022 20.2013 14.4263 20.4678 14.8592C20.5561 15.0025 20.6367 15.1678 20.6918 15.3515Z'
        />
    ),
})

TakingSamplesIcon.displayName = 'TakingSamplesIcon'
